import { composeEllipsisAriaLabelText } from '../strings.locstring.json';
import loc from 'owa-localize';
import { observer as observerLite } from 'mobx-react-lite';
/* tslint:disable:jsx-no-lambda WI:47713 */
import { CommandBar, ICommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { observer } from 'mobx-react';
import { ControlIcons } from 'owa-control-icons';

import * as React from 'react';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import {
    SurfaceActionItem,
    onCommandBarDataReduced,
    onCommandBarDataGrown,
} from 'owa-surface-actions';
import { CommandBarButton, IButtonProps } from 'office-ui-fabric-react/lib/Button';

const styles = require('./ComposeBottom.scss');

export interface ComposeToolbarItem extends IContextualMenuItem {
    imageUrl?: string;
    customRender?: (className: string) => JSX.Element;
}

export interface ComposeBottomActionBarProps {
    items: SurfaceActionItem[];
    overflowItems: SurfaceActionItem[];
}

const ComposeToolbarButton = observerLite((props: IButtonProps) => (
    <CommandBarButton
        {...props}
        styles={{
            root: styles.commandBarButton,
            rootChecked: styles.checkedCommandBarButton,
            rootDisabled: styles.disabledCommandBarButton,
            menuIcon: styles.commandBarMenuIcon,
        }}
    />
));

/**
 * Hosts the custom surface actions in ComposeBottom.
 */
@observer
export default class ComposeBottomActionBar extends React.Component<
    ComposeBottomActionBarProps,
    {}
> {
    private commandBar: ICommandBar;

    render() {
        const { items, overflowItems } = this.props;
        return (
            <CommandBar
                componentRef={commandBar => (this.commandBar = commandBar)}
                items={items}
                overflowItems={overflowItems}
                overflowButtonProps={{
                    menuIconProps: {
                        iconName: ControlIcons.More,
                        styles: {
                            root: styles.commandBarOverflowIcon,
                        },
                    },
                    ariaLabel: loc(composeEllipsisAriaLabelText),
                }}
                buttonAs={ComposeToolbarButton}
                overflowButtonAs={ComposeToolbarButton}
                className={styles.surfaceActionsCommandBar}
                onDataReduced={onCommandBarDataReduced}
                onDataGrown={onCommandBarDataGrown}
            />
        );
    }

    componentWillUnmount() {
        this.commandBar = null;
    }

    resize() {
        if (this.commandBar) {
            this.commandBar.remeasure();
        }
    }
}
